import * as Tooltip from "@radix-ui/react-tooltip";
import { FiAlertCircle } from "react-icons/fi";
import React from "react";

const ErrorIconWithTooltip = ({ message }: { message: string }) => {
  return (
    <Tooltip.Provider>
      <Tooltip.Root>
        <Tooltip.Trigger asChild>
          <span style={{ display: "inline-flex", cursor: "pointer" }}>
            <FiAlertCircle color="red" size={20} />
          </span>
        </Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Content
            side="top"
            sideOffset={5}
            style={{
              backgroundColor: "#333",
              color: "#fff",
              padding: "6px 10px",
              borderRadius: 4,
              fontSize: 12,
              zIndex: 1000,
              boxShadow: "0px 0px 10px rgba(0,0,0,0.2)",
            }}
          >
            {message}
            <Tooltip.Arrow offset={5} style={{ fill: "#333" }} />
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
};

export default ErrorIconWithTooltip;
